import { render, staticRenderFns } from "./AegisLead.vue?vue&type=template&id=f454b724&"
import script from "./AegisLead.vue?vue&type=script&lang=js&"
export * from "./AegisLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports